

const achievements = [
  ["😱", "Extrovert", 0, 0],
  ["😐", "Vibe killer", 0, 1],
  ["😸", "Pussy expert", 0, 2],
  ["💤", "Wet dreams", 0, 3],
  ["👯‍♀️", "Doppelgänger", 0, 4],
  ["🙅‍♂️", "Way off track", 0, 5],
  ["💦", "Impress professor", 0, 6],
  ["✍️", "Helper", 0, 7],
];

export default achievements;
